import { z } from 'zod';
import { useMutation, request } from '@applyboard/ui-utils';

const ExtractedPassportInfoSchema = z.object({
  birth_date: z.string(),
  country: z.string(),
  expiry_date: z.string(),
  name: z.string(),
  nationality: z.string(),
  sex: z.string(),
  surname: z.string(),
  document_number: z.string(),
  place_of_birth: z.string(),
  mrz: z.unknown(),
  metadata: z.unknown(),
});

export type ExtractedPassportInfo = z.infer<typeof ExtractedPassportInfoSchema>;

export function useExtractPassportInfo() {
  const { mutate, isLoading } = useMutation(async ({ file }: { file: File }) => {
    const formData = new FormData();
    formData.append('passport', file);
    return await request(`/api/rpj-bff/v1/ocr/passport_info_extraction`, {
      method: 'POST',
      body: formData,
      schema: ExtractedPassportInfoSchema,
    });
  });

  return {
    extractPassportInfo: mutate,
    isExtractingPassportInfo: isLoading,
  };
}
